import {
  prepareCategoryFilters,
  prepareLocationFilters,
  prepareRoomsFilters,
  prepareStatusFilters,
} from './prepareFilters';
import { prepareOffers } from './prepareOffers';
import { IGetHouseOfferHistoryByHouseIdResponse } from '../../../repositories/valuation-offer-history/v1/get-house-offer-history-by-house-id';
import { IOffersHistoryListingData } from '../../../types/offerHistory';
import { EDealType } from '../../../types/dealType';

export const prepareOffersHistory = (
  res: IGetHouseOfferHistoryByHouseIdResponse,
  dealType: EDealType,
): IOffersHistoryListingData => {
  const offers: IOffersHistoryListingData['offers'] = prepareOffers(res.offers, dealType);
  const statusFilters = prepareStatusFilters(res.statusCounts, dealType);
  const roomsFilters = prepareRoomsFilters(res.roomCounts);
  const locationFilters = prepareLocationFilters(res.locations);
  const categoriesFilters = prepareCategoryFilters(res.categories);

  return {
    offers,
    roomsFilters,
    statusFilters,
    locationFilters,
    totalCount: res.totalCount,
    activeFiltersValues: res.activeFiltersValues,
    categoriesFilters,
  };
};
